













































































































































































































import { Editor } from '@tiptap/core';
import MainButton from '@/main-components/common/MainButton.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    MainButton,
  },
})
export default class ActionTable extends Vue {
  @Prop()
  editor: Editor;
}
